document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector("header");
  const extraOffset = 20; // 任意の追加オフセット

  links.forEach(link => {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      const href = this.getAttribute("href");
      if (!href || href === "#") return; // hrefが不正なら処理しない

      const targetId = href.replace("#", "");
      const target = document.getElementById(targetId);

      if (!target) {
        console.warn(`スクロールターゲットが見つかりません: ${targetId}`);
        return;
      }

      // `offsetTop` が正しく計算されるように、最も近い `offsetParent` を取得
      let position = target.getBoundingClientRect().top + window.scrollY;

      // ヘッダーの高さを考慮してスクロール位置を調整
      const headerHeight = header ? header.offsetHeight : 0;
      position -= headerHeight + extraOffset;

      console.log(`スクロール対象: ${targetId}, スクロール位置: ${position}`);

      window.scrollTo({
        top: position,
        behavior: "smooth"
      });
    });
  });
});
// コレクションテンプレート、ページ内リンクスムーススクロールスクリプト